import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";

dayjs.extend(customParseFormat);

export const validateDob = (dob: string) => {
  if (dob.length < 10) {
    return "Date of birth must be at least 8 characters long.";
  }

  const date = dayjs(dob, "MM/DD/YYYY", true);
  const today = dayjs();

  if (!date.isValid() || !date.isBefore(today)) {
    return "Invalid date of birth. It should be a valid date before today in MM/DD/YYYY format.";
  }

  if (dayjs().diff(date, "year", true) < 18) {
    return "Sorry, we can't qualify patients under 18 years old.";
  }

  // DESC: We show accept consent for over 65 years old
  // if (dayjs().diff(date, "year", true) > 65) {
  //   return "Sorry, we can't qualify patients over 65 years old.";
  // }

  return "";
};

export const isYounger64 = (dob: string | null) => {
  if (!dob) return false;

  const date = dayjs(dob, "MM/DD/YYYY", true);

  if (!date.isValid()) {
    return false;
  }

  return dayjs().diff(date, "year", true) < 64;
};
